import React from 'react';
import ReactDOM from 'react-dom';
// import { fetchData } from '../../helpers/base_data_fetcher';
import BoldModal from '../account/components/BoldModal.jsx';

const mountElement = document.getElementById('boldModal');

export default function explanationboldModal() {
  if (mountElement) {
    ReactDOM.render(<BoldModal />, mountElement);
  }
}
